import { ModelSagres } from "../model-sagres"

export class Oscip extends ModelSagres {
    IdPerdaQualificacao: number
    NrCnpj: string
    NmEntidade: string
    DeEndereco: string
    NmCidade: string
    NmUf: string
    NmCep: string
    DtPublicacaoDou: Date
    DeTipoDocumento: string
    FlAtivo: boolean
    CrpArquivosPerdaQualificacaoOscip: any
    
    nmArquivo: string
    arquivo: File

    tratarDadosDaAPI(): void {
        if (this.DtPublicacaoDou) {
            this.DtPublicacaoDou = new Date(this.DtPublicacaoDou)
        }
        // só existe 1 arquivo anexo para cada Perda de Qualificação OSCIP
        if (this.CrpArquivosPerdaQualificacaoOscip.length > 0) {
            this.nmArquivo = this.CrpArquivosPerdaQualificacaoOscip[0].NmArquivo
        }
    }

}